import * as i0 from "@angular/core";
import * as i1 from "../questionnaire/questionnaire.service";
import * as i2 from "../experiments/experiments.service";
import * as i3 from "../app-initialization.service";
export class CanActivateQuestionaireGuard {
    constructor(questionnaireService, experimentService, appInitializationService) {
        this.questionnaireService = questionnaireService;
        this.experimentService = experimentService;
        this.appInitializationService = appInitializationService;
    }
    canActivate(next, state) {
        if (next && next.queryParams && next.queryParams.uo && !this.questionnaireService.llc.currentView) {
            this.questionnaireService.llc.bFunnelTest = this.experimentService.GetBFunnelTestValue();
            this.questionnaireService.llc.bShowPriceTest = this.experimentService.GetBShowPriceTestValue();
            this.questionnaireService.llc.bShowPriceTest1 = this.experimentService.GetBShowPriceTest1Value();
        }
        return this.appInitializationService.initializeApp(state.url);
    }
}
CanActivateQuestionaireGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanActivateQuestionaireGuard_Factory() { return new CanActivateQuestionaireGuard(i0.ɵɵinject(i1.QuestionnaireService), i0.ɵɵinject(i2.ExperimentsService), i0.ɵɵinject(i3.AppInitializationService)); }, token: CanActivateQuestionaireGuard, providedIn: "root" });
